import React from 'react'
import { graphql, HeadProps } from 'gatsby'

import Seo from '@src/components/Seo'
import CategoryLayout from '@src/components/CategoryLayout'
import { Article } from '@models/Article'
import { useTranslation } from '@models/Translation'

type CategoryTemplateContext = {
  category: string
}
type CategoryTemplateProps = {
  data: {
    allArticle: {
      nodes: Article[]
    }
    allEnglishArticle: {
      nodes: Article[]
    }
  }
  pageContext: CategoryTemplateContext
}
const CategoryTemplate: React.FC<CategoryTemplateProps> = ({
  data,
  pageContext,
}) => {
  const { locale } = useTranslation()
  const articles =
    locale === 'en' ? data.allEnglishArticle.nodes : data.allArticle.nodes

  return <CategoryLayout articles={articles} category={pageContext.category} />
}

export const Head = ({
  pageContext,
  location,
}: HeadProps<unknown, CategoryTemplateContext>) => {
  const category = pageContext.category
  const title = category.toUpperCase()

  return <Seo pathName={location.pathname} title={title} />
}

export default CategoryTemplate

export const query = graphql`
  query ($category: String!) {
    allArticle(
      filter: { data: { category: { eq: $category } } }
      sort: { rawPublishDate: DESC }
    ) {
      nodes {
        blogId
        path
        title
        thumbnail {
          url
          width
          height
        }
        publishDate
        parentPage {
          id
        }
        data {
          category
          requester
        }
        enableVoice
        isMembersOnly
      }
    }
    allEnglishArticle(
      filter: { data: { category: { eq: $category } } }
      sort: { rawPublishDate: DESC }
    ) {
      nodes {
        blogId
        path
        title
        thumbnail {
          url
          width
          height
        }
        publishDate
        parentPage {
          id
        }
        data {
          category
          requester
        }
        enableVoice
        isMembersOnly
      }
    }
  }
`
